import { render, staticRenderFns } from "./RecordScreen.vue?vue&type=template&id=6899d31e&"
import script from "./RecordScreen.vue?vue&type=script&lang=js&"
export * from "./RecordScreen.vue?vue&type=script&lang=js&"
import style0 from "./RecordScreen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports